import './section_video_background.less';

import $ from 'jquery';
import React, { Component, Fragment } from 'react';
import { findDOMNode } from 'react-dom';
import autobind from 'class-autobind';
import PropTypes from 'prop-types';

import { VisuallyHiddenSpan } from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

import {
  PlayIcon,
  PauseIcon,
  StopIcon,
  HideIcon,
  ShowIcon
} from 'zoomforth_component_lib/external_modern_icons.jsx';

const SectionVideoBackground_ViewerVersion1 = ({
  mpeg4Source,
  mpeg4LowQualitySource,
  posterImage,
  shouldBackgroundVideoLoop,
  backgroundVideoColor,
  backgroundVideoObjectFit,
  backgroundVideoObjectPosition
})=> (
  <div className="section-video-background" style={{ backgroundColor: backgroundVideoColor }}>
    <video
      muted
      autoPlay
      preload="auto"
      width="100%"
      height="100%"
      poster={posterImage}
      loop={shouldBackgroundVideoLoop}
      data-object-fit={backgroundVideoObjectFit}
      data-object-position={backgroundVideoObjectPosition}
      style={{
        objectFit: backgroundVideoObjectFit,
        objectPosition: backgroundVideoObjectPosition
      }}
    >
      <source
        src={mpeg4Source}
        type="video/mp4"
        data-res="480p"
        data-default="true"
      />
      <source
        src={mpeg4LowQualitySource}
        type="video/mp4"
        data-res="240p"
      />
    </video>
  </div>
);

/*
 * Accessibility criteria requires that we have controls which can play, pause,
 * and hide any video backgrounds. The native HTML5 video player alone is not
 * great since those controls typically cannot be tabbed into. Instead we
 * create buttons which will give a user the ability to tab through and manage
 * the video status on their own.
 *
 * https://developer.mozilla.org/en-US/docs/Learn/Accessibility/Multimedia#accessible_audio_and_video_controls
 */
class SectionVideoBackground_ViewerVersion2 extends Component {

  constructor() {
    super();

    this.state = {
      isPlaying: false,
      isPaused: false,
      isHidden: false,
      hasInteractedWithControls: false
    };

    this.videoPlayer = null;
    this.playPauseBtn = null;

    autobind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.shouldAutoplayBackgroundVideo !== this.props.shouldAutoplayBackgroundVideo) {
      if (this.videoPlayer) {
        if (this.props.shouldAutoplayBackgroundVideo) {
          this.videoPlayer.play();
          this.setState({
            isPlaying: true,
            isPaused: false
          });
        } else {
          this.videoPlayer.pause();
          this.setState({
            isPlaying: false,
            isPaused: true
          });
        }
      }
    }
  }

  handlePlayPauseClick() {
    if (this.videoPlayer) {
      if (this.videoPlayer.paused) {
        this.videoPlayer.play();
        this.setState({
          isPlaying: true,
          isPaused: false,
          hasInteractedWithControls: true
        });

      } else {
        this.videoPlayer.pause();
        this.setState({
          isPlaying: false,
          isPaused: true,
          hasInteractedWithControls: true
        });
      }
    }
  }

  handleStopClick() {
    if (this.videoPlayer) {
      this.videoPlayer.pause();
      this.videoPlayer.currentTime = 0;

      this.setState({
        isPlaying: false,
        isPaused: false,
        hasInteractedWithControls: true
      });

      if (this.playPauseBtn) {
        $(findDOMNode(this.playPauseBtn)).focus();
      }
    }
  }

  handleHideShowClick() {
    const { isHidden } = this.state;

    this.setState({
      isHidden: !isHidden,
      isPlaying: false,
      isPaused: false,
      hasInteractedWithControls: true
    });

    if (!isHidden) {
      this.videoPlayer = null;
      this.playPauseBtn = null;
    }
  }

  handleVideoPlayerRefReceived(videoPlayerRef) {
    this.videoPlayer = videoPlayerRef;

    if (this.props.shouldAutoplayBackgroundVideo) {
      if (this.videoPlayer) {
        this.videoPlayer.play();
        this.setState({
          isPlaying: true,
          isPaused: false
        });
      }
    }
  }

  handlePlayPauseBtnRefReceived(playPauseBtnRef) {
    const { hasInteractedWithControls } = this.state;

    this.playPauseBtn = playPauseBtnRef;

    if (hasInteractedWithControls) {
      $(findDOMNode(this.playPauseBtn)).focus();
    }
  }

  render() {
    const {
      mpeg4Source,
      mpeg4LowQualitySource,
      posterImage,
      shouldBackgroundVideoLoop,
      backgroundVideoColor,
      backgroundVideoObjectFit,
      backgroundVideoObjectPosition
    } = this.props;

    const {
      isHidden,
      isPlaying,
      isPaused
    } = this.state;

    return (
      <Fragment>
      <div
        className="section-video-background"
        style={{ backgroundColor: backgroundVideoColor }}
      >
        {
          !isHidden &&
            <video
              muted
              ref={this.handleVideoPlayerRefReceived}
              preload="auto"
              width="100%"
              height="100%"
              tabIndex="-1"
              poster={posterImage}
              loop={shouldBackgroundVideoLoop}
              data-object-fit={backgroundVideoObjectFit}
              data-object-position={backgroundVideoObjectPosition}
              style={{
                objectFit: backgroundVideoObjectFit,
                objectPosition: backgroundVideoObjectPosition
              }}
            >
              <source
                src={mpeg4Source}
                type="video/mp4"
                data-res="480p"
                data-default="true"
              />
              <source
                src={mpeg4LowQualitySource}
                type="video/mp4"
                data-res="240p"
              />
            </video>
        }
      </div>
      <div className="section-video-background-controls">
          {
            !isHidden &&
              <button
                className="playpause-btn"
                ref={this.handlePlayPauseBtnRefReceived}
                onClick={this.handlePlayPauseClick}
              >
                { isPlaying ?  <PauseIcon /> : <PlayIcon /> }
                <VisuallyHiddenSpan>
                  { isPlaying ?  'Pause' : 'Play' }
                </VisuallyHiddenSpan>
              </button>
          }

          {
            ((isPlaying || isPaused) && !isHidden) &&
              <button className="stop-btn" onClick={this.handleStopClick}>
                <StopIcon />
                <VisuallyHiddenSpan>
                  Stop
                </VisuallyHiddenSpan>
              </button>
          }

          <button className="hideshow-btn" onClick={this.handleHideShowClick}>
            { isHidden ?  <ShowIcon /> : <HideIcon /> }
            <VisuallyHiddenSpan>
              { isHidden ?  'Show video' : 'Hide video' }
            </VisuallyHiddenSpan>
          </button>
        </div>
      </Fragment>
    );
  }
}

const SectionVideoBackground = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SectionVideoBackground_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <SectionVideoBackground_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

SectionVideoBackground.propTypes = {
  mpeg4Source: PropTypes.string,
  mpeg4LowQualitySource: PropTypes.string,
  posterImage: PropTypes.string,
  shouldBackgroundVideoLoop: PropTypes.bool
};

export default SectionVideoBackground;
